/**
 * ConflictList — renders a list of conflict cards with action handlers.
 */

import { useState } from 'react';
import { ConflictCard } from './ConflictCard';
import { ResolveConflictDialog } from './ResolveConflictDialog';
import type { BuddyGroupConflict } from '../types/conflict';

interface ConflictListProps {
  conflicts: BuddyGroupConflict[];
  canDismiss: boolean;
  canResolve: boolean;
}

export function ConflictList({ conflicts, canDismiss, canResolve }: ConflictListProps) {
  const [dialogState, setDialogState] = useState<{
    conflict: BuddyGroupConflict;
    action: 'dismiss' | 'resolve';
  } | null>(null);

  return (
    <>
      <div className="space-y-3">
        {conflicts.map((c) => (
          <ConflictCard
            key={c.id}
            conflict={c}
            canDismiss={canDismiss}
            canResolve={canResolve}
            onDismiss={(conflict) => setDialogState({ conflict, action: 'dismiss' })}
            onResolve={(conflict) => setDialogState({ conflict, action: 'resolve' })}
          />
        ))}
      </div>

      {dialogState && (
        <ResolveConflictDialog
          conflict={dialogState.conflict}
          action={dialogState.action}
          open={!!dialogState}
          onClose={() => setDialogState(null)}
        />
      )}
    </>
  );
}
